module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/e12973d6652a6f48fae30237797babeb.png";